if (!customElements.get('hc-collection-nav')) {
  class HcCollectionNav extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.dotNodes = [];
    }

    connectedCallback() {
      const viewport = this.querySelector('[data-js="viewport"]');
      const indicator = this.querySelector('[data-js="indicator"]');

      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      this.embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      // Scroll active item into view on init
      var activeEl = this.querySelector('.hc-collection-nav__item--active');
      if (activeEl) {
        var slides = this.embla.slideNodes();
        var activeIndex = slides.indexOf(activeEl);
        if (activeIndex > 0) {
          this.embla.scrollTo(activeIndex, true);
        }
      }

      // Center items when they all fit in the viewport
      if (this.embla.scrollSnapList().length <= 1) {
        this.classList.add('hc-collection-nav--centered');
      }

      if (indicator) {
        this.buildDots(indicator);
        this.embla.on('select', () => this.updateDots());
        this.embla.on('reInit', () => {
          this.buildDots(indicator);
          this.updateDots();
          // Re-check centering after reInit (e.g. resize)
          this.classList.toggle(
            'hc-collection-nav--centered',
            this.embla.scrollSnapList().length <= 1
          );
        });
      }
    }

    disconnectedCallback() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
    }

    buildDots(container) {
      const snaps = this.embla.scrollSnapList();
      container.innerHTML = '';
      this.dotNodes = [];

      snaps.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'hc-collection-nav__dot';
        dot.setAttribute('aria-label', 'Go to group ' + (i + 1));
        dot.addEventListener('click', () => this.embla.scrollTo(i));
        container.appendChild(dot);
        this.dotNodes.push(dot);
      });

      this.updateDots();
    }

    updateDots() {
      if (!this.embla || !this.dotNodes.length) return;
      const selected = this.embla.selectedScrollSnap();
      this.dotNodes.forEach((dot, i) => {
        dot.classList.toggle('hc-collection-nav__dot--active', i === selected);
      });
    }
  }

  customElements.define('hc-collection-nav', HcCollectionNav);
}
